import { floorDate } from './date-rounding'

export function isBeforeToday(date: Date) {
  const normalizedToday = floorDate(new Date(), { unit: 'day' })
  const normalizedDate = floorDate(date, { unit: 'day' })

  return normalizedDate < normalizedToday
}
